<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>

		<main-content :title="page.title || page.header" :content="page.content" :subtitle="page.subtitle">
			<div class="columns column12">
				<recursive-sitemap :items="sitemap" />
			</div>
		</main-content>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

const { data: sitemap } = await useWebsiteFetch('sitemap', {
	query: { language: locale.value },
	key: `${locale.value}/sitemap`,
});
</script>
